export default __webpack_public_path__ + "static/media/education.12cec0a9.svg";